<template>
  <div
    class="tm-detail-overlay tm-menue-overlay"
    :style="dragStyle"
    @pointermove="ziehenBewegen"
    @pointerup="ziehenEnde"
    @pointercancel="ziehenEnde"
  >
    <div class="tm-sheet-griff" @pointerdown="ziehenStart">
      <div class="tm-sheet-griff-inner"></div>
      <button type="button" class="tm-sheet-griff__schliessen" aria-label="Schließen" @pointerdown.stop @click="$emit('close')">✕</button>
    </div>
    <div class="tm-detail-overlay__kopf">
      <span class="tm-detail-overlay__titel">Menü</span>
    </div>

    <div class="tm-detail-overlay__inhalt tm-detail-overlay__inhalt--einfach" v-scroll-melden>
    <div class="tm-menue-liste">
      <button type="button" class="tm-menue-eintrag" @click="$emit('toggle-favoriten')">
        <span class="tm-menue-eintrag__icon">★</span>
        <span class="tm-menue-eintrag__text">
          <span class="tm-menue-eintrag__label">Nur Favoriten anzeigen</span>
          <span class="tm-menue-eintrag__hinweis">Spiele-Filter: zeigt nur Spiele mit favorisierten Teams</span>
        </span>
        <span :class="['tm-menue-schalter', { 'tm-menue-schalter--an': nurFavoriten }]">
          <span class="tm-menue-schalter__knopf"></span>
        </span>
      </button>

      <button type="button" class="tm-menue-eintrag" @click="$emit('oeffne-rangliste')">
        <span class="tm-menue-eintrag__icon">🏆</span>
        <span class="tm-menue-eintrag__label">Rangliste</span>
        <span class="tm-menue-eintrag__pfeil">›</span>
      </button>

      <button type="button" class="tm-menue-eintrag" @click="$emit('toggle-vollbild')">
        <span class="tm-menue-eintrag__icon">⛶</span>
        <span class="tm-menue-eintrag__label">Vollbild</span>
        <span :class="['tm-menue-schalter', { 'tm-menue-schalter--an': istVollbild }]">
          <span class="tm-menue-schalter__knopf"></span>
        </span>
      </button>
    </div>
    </div>
  </div>
</template>

<script setup>
import { useSheetDrag } from '../composables/useSheetDrag.js'
import { vScrollMelden } from '../lib/scrollLock.js'

defineProps({
  nurFavoriten: { type: Boolean, default: false },
  istVollbild: { type: Boolean, default: false }
})
const emit = defineEmits(['close', 'toggle-favoriten', 'oeffne-rangliste', 'toggle-vollbild'])

const { ziehenStart, ziehenBewegen, ziehenEnde, dragStyle } = useSheetDrag(() => emit('close'))
</script>